.lista {
  margin: 0;
  display: flex;
  flex-direction: column;
}
.lista[data-tone="bordered"] {
  border: var(--bw-hair) solid var(--border-hair);
  border-radius: var(--r-panel);
  background: var(--surface-card);
  overflow: hidden;
}
.fila {
  display: grid;
  grid-template-columns: minmax(120px, 2fr) 3fr;
  gap: var(--s-2) var(--s-6);
  align-items: baseline;
  padding: var(--s-5) 0;
}
.lista[data-tone="bordered"] .fila {
  padding: var(--s-5) var(--s-6);
  border-bottom: var(--bw-hair) solid var(--border-hair);
}
.lista[data-tone="bordered"] .fila:last-child {
  border-bottom: none;
}
.lista[data-layout="stacked"] .fila {
  grid-template-columns: 1fr;
}
.clave {
  margin: 0;
  font-family: var(--font-body);
  font-size: var(--fs-xs);
  font-weight: var(--fw-medium);
  color: var(--text-muted);
}
.valor {
  margin: 0;
  min-width: 0;
  font-family: var(--font-body);
  font-size: var(--fs-sm);
  color: var(--text-strong);
  overflow-wrap: anywhere;
}
.valor[data-mono] {
  font-family: var(--font-mono);
  font-variant-numeric: tabular-nums;
}
@media (max-width: 767px) {
  .fila {
    grid-template-columns: 1fr;
  }
}
